import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const OPTS = [["passed", "Bestanden", "bg-emerald-600 border-emerald-600"], ["failed", "Nicht bestanden", "bg-red-600 border-red-600"], ["absent", "Nicht teilgenommen", "bg-slate-600 border-slate-600"]];

export default function ExamResultCard({ participant }) {
  const [val, setVal] = useState(participant.exam_result || null);
  const set = async (v) => {
    const next = v === val ? null : v;
    try {
      await api.put(`/audit/exam/${participant.participant_id}`, { result: next });
      setVal(next);
      toast.success("Prüfungsergebnis gespeichert");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  return (
    <div className="border border-slate-200 bg-white px-5 py-3 flex items-center gap-3 flex-wrap" data-testid="wb-exam-card">
      <span className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mr-2">Abschlussprüfung</span>
      {OPTS.map(([k, l, active]) => (
        <button key={k} onClick={() => set(k)} data-testid={`wb-exam-${k}`}
          className={`px-3 py-1.5 text-xs font-medium border transition-colors ${val === k ? `${active} text-white` : "border-slate-200 text-slate-600 hover:bg-slate-100"}`}>{l}</button>
      ))}
      {!val && <span className="text-xs text-slate-400" data-testid="wb-exam-none">noch nicht eingetragen</span>}
    </div>
  );
}
